
import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation, useNavigate, Navigate } from 'react-router-dom';
// import '../FirstPage.css'
import '../FirstPageDesigns/FirstPage.css';
import changeServicesUser from '../../../Assets/changeServicesUser.png'
// import QuotationUpdate from './QuotationUpdate';
import QuotationUpdate from './QuotationUpdate';
import StatusTracking from './StatusTracking.jsx';
import HistoryReceipts from './HistoryReceipts';
import BottomNavigationBar from '../../../Component/Customers/BottomNavigationBar.jsx';
import Modal from '../../../Component/CompanyAdmin/Location1/Modal.jsx';
import AllCancelledOrders from './AllCancelledOrders.jsx';
import advocatecurrentservice from "../../../Assets/advocatecurrentservice.jpg"
import mechaniccurrentservice from "../../../Assets/mechaniccurrentservice.jpg"
import workshopcurrentservice from "../../../Assets/workshopcurrentservice.jpg"
import search from '../../../Assets/home2/search.svg'
import img1 from '../../../Assets/crane/img1.png'
import icon1 from '../../../Assets/crane/icon1.svg'
import icon2 from '../../../Assets/crane/icon2.svg'
import icon3 from '../../../Assets/crane/icon3.svg'
import icon4 from '../../../Assets/crane/icon4.svg'
import icon5 from '../../../Assets/crane/icon5.svg'
import dropdown from '../../../Assets/crane/dropdown.png'
import dropup from '../../../Assets/crane/dropUp.png'

const CraneFirstPage = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const location = useLocation();
    console.log("Statehere", state?.indexFor)
    console.log("Statehere", state?.vehicleNumber)

    const [selectedIndex, setSelectedIndex] = useState(state?.indexFor || 0);
    const [vehicleNumber, setVehicleNumber] = useState(state?.vehicleNumber || 0);
    const [vehicleNo, setVehicleNo] = useState(state?.vehicleNo || 0);
    const [goToNextPage, setGoToNextPage] = useState(false)
    console.log("goToNextPage", goToNextPage)
    const [center, setCenter] = useState(state?.center || 0);
    const [openServiceModal, setOpenServiceModal] = useState(false)


    console.log("selectedIndex", selectedIndex)

    const handleSelect = (index) => {
        setSelectedIndex(index);
        const paths = ['tracking', 'quotationupdate', 'history', 'cancelled'];
        navigate(`/Crane-dashboard/${paths[index]}`);
    };

    useEffect(() => {
        const path = location.pathname.split('/')[2]; // e.g., 'tracking'
        const paths = ['tracking', 'quotationupdate', 'history', 'cancelled'];
        const foundIndex = paths.indexOf(path);
        setSelectedIndex(foundIndex !== -1 ? foundIndex : 0);
    }, [location.pathname]);

    useEffect(() => {
        if (selectedIndex !== state?.indexFor) {
            setVehicleNumber("");
        }
    }, [selectedIndex, state?.indexFor]);

    const [choosenService, setChoosenService] = useState(() => localStorage.getItem("currentService") || 'crane')

    useEffect(() => {
        if (state?.service) {
            console.log('stat?.service', state?.service)
            localStorage.setItem('currentService', state?.service)
            if (localStorage.getItem("currentService") === state?.service) {
                setGoToNextPage(true)
                setChoosenService(state?.service)
            }
        }
        else {
            if (localStorage.getItem("currentService") === null) localStorage.setItem('currentService', 'crane')
        }
    }, [])
    const chooseCurrentService = (service) => {
        setChoosenService(service);
        localStorage.setItem("currentService", service)
        setOpenServiceModal(!openServiceModal)
    }

    return (
        <div>
            {/* <div className="start-container" style={{ height: "40px", zIndex: "10", margin: "0px 0px 0px 0px", position: "sticky", top: "0.1px" }}>
                <div className="imageContainer" style={{ marginTop: "10px", height: "0px" }}>
                    {["Status tracking", "Quotation & Updates", 'History & Receipts', 'Cancelled Orders', "Summary & Reviews"].map((text, index) => (
                        <div
                            key={index}
                            style={{ cursor: 'pointer' }}
                            className={`imageWrapper ${selectedIndex === index ? "selected" : ""}`}
                            onClick={() => handleSelect(index)}
                        >
                            <div className="top-scrolling">
                                <p>{text}</p>
                            </div>
                        </div>
                    ))}


                </div>
            </div> */}


            <div style={{
                position: "sticky", top: '150px', zIndex: "1000", margin: "-180px 20px 0px", width: "70px", background: 'linear-gradient(45deg, white, transparent)', borderRadius: "10px",
                paddingTop: "3px",
                paddingLeft: "3px",
                paddingRight: "3px",
            }}>
                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/changeServicesUser.png' style={{ height: '20px', width: "20px" }} onClick={() => setOpenServiceModal(!openServiceModal)} />
            </div>


            <Modal isOpen={openServiceModal} onClose={() => setOpenServiceModal(!openServiceModal)}>
                {openServiceModal && (
                    <div style={{ textAlign: "center", flexDirection: "column", display: 'flex', alignItems: 'center', justifyContent: "center" }}>
                        <p style={{ color: "green", fontWeight: "bold", marginBottom: "10px", fontSize: "15px", border: "1px solid red", background: "#ffffffa6", minWidth: "200px", borderRadius: "20px", padding: "10px" }} onClick={() => chooseCurrentService('advocate')}>Advocate</p>
                        <p style={{ color: "green", fontWeight: "bold", marginBottom: "10px", fontSize: "15px", border: "1px solid red", background: "#ffffffa6", minWidth: "200px", borderRadius: "20px", padding: "10px" }} onClick={() => chooseCurrentService('crane')}>Crane</p>
                        <p style={{ color: "green", fontWeight: "bold", marginBottom: "10px", fontSize: "15px", border: "1px solid red", background: "#ffffffa6", minWidth: "200px", borderRadius: "20px", padding: "10px" }} onClick={() => chooseCurrentService('mechanic')}>Mechanic</p>
                        <p style={{ color: "green", fontWeight: "bold", marginBottom: "10px", fontSize: "15px", border: "1px solid red", background: "#ffffffa6", minWidth: "200px", borderRadius: "20px", padding: "10px" }} onClick={() => chooseCurrentService('workshop')}>Workshop</p>
                        <p style={{ color: "green", fontWeight: "bold", marginBottom: "10px", fontSize: "15px", border: "1px solid red", background: "#ffffffa6", minWidth: "200px", borderRadius: "20px", padding: "10px" }} onClick={() => chooseCurrentService('recoveryVan')}>Recovery</p>

                    </div>
                )}
            </Modal>

            <div className='crane-section' style={{ marginTop: '120px' }}>
                <h6 className="font-[700] text-center font-satoshi text-[61px] leading-[68px] text-[#FFFFFF] pt-[52px] mb-0 pb-[72px]">
                    {choosenService.charAt(0).toUpperCase() + choosenService.slice(1)} Services
                </h6>
                <div style={{ backdropFilter: "blur(20px)" }} className="flex bg-[#FFFFFF4D] max-w-[736px] w-full mx-auto py-[28px] rounded-[66px] pl-[40px] mb-[78px] pr-[28px] items-center justify-between">
                    <input type="text" className='outline-none bg-transparent text-[#FFFFFF] placeholder:text-[#FFFFFF] font-[500] text-[16px] leading-[20px]' placeholder='Search By Service' />
                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/home2/search.svg' className='h-[20px] w-[20px]' alt="" />
                </div>
            </div>

            <div className="flex-1">
                <Routes>
                    <Route path="/" element={<Navigate to="tracking" />} />
                    <Route path="tracking" element={<StatusTracking vehicleNumber={vehicleNumber} />} />
                    <Route path="quotationupdate" element={<QuotationUpdate vehicleNumber={vehicleNumber} />} />
                    <Route path="history" element={<HistoryReceipts vehicleNumber={vehicleNumber} />} />
                    <Route path="cancelled" element={<AllCancelledOrders vehicleNumber={vehicleNumber} />} />
                </Routes>
            </div>


            <div >
                <BottomNavigationBar />
            </div>
        </div>
    )
}

export default CraneFirstPage;
